var map = {
	"./addresses.svg": "./src/assets/illustrations/reports/addresses.svg",
	"./affiliate-overview.svg": "./src/assets/illustrations/reports/affiliate-overview.svg",
	"./bank-transactions.svg": "./src/assets/illustrations/reports/bank-transactions.svg",
	"./cards.svg": "./src/assets/illustrations/reports/cards.svg",
	"./coin-transactions.svg": "./src/assets/illustrations/reports/coin-transactions.svg",
	"./due-payments.svg": "./src/assets/illustrations/reports/due-payments.svg",
	"./orders.svg": "./src/assets/illustrations/reports/orders.svg",
	"./rewards.svg": "./src/assets/illustrations/reports/rewards.svg",
	"./staking.svg": "./src/assets/illustrations/reports/staking.svg",
	"./swaps.svg": "./src/assets/illustrations/reports/swaps.svg",
	"./transfer.svg": "./src/assets/illustrations/reports/transfer.svg",
	"./wages-list.svg": "./src/assets/illustrations/reports/wages-list.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/illustrations/reports sync recursive ^\\.\\/.*\\.svg$";